import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from 'src/app/state/action-sources';
import { GetBlueSageTerminalsQuery } from 'src/generated/graphql.generated';

export const BlueSageTerminalPickerActions = createActionGroup({
    source: ActionSource.BLUESAGE_TERMINAL_PICKER,
    events: {
        'Picker Opened': emptyProps(),
        'Refresh Button Clicked': emptyProps(),

        'Load Terminals Success': props<{
            terminals: GetBlueSageTerminalsQuery['blueSageTerminals'];
        }>(),
        'Load Terminals Error': props<{ error: Error }>(),

        // Requirement: filtering is client-side and instant. The whole roster
        // arrives in ONE `blueSageTerminals` call, so there is nothing to debounce
        // and no round trip to wait for — an operator typing `79` should see the
        // list narrow on the `7`, not 300 ms after the `9`.
        // A busy location has thirty terminals and this picker lives inside a
        // payment dialog, so the roster is collapsed to a shortlist by default.
        'Show All Terminals Button Clicked': emptyProps(),
        'Show Fewer Terminals Button Clicked': emptyProps(),

        'Search Changed': props<{ search: string }>(),

        // Selection is NOT a claim on the device. A driver and an office operator
        // may both have the picker open on the same terminal; that is normal and
        // must not mark it busy. The lock is taken server-side when Send is
        // pressed, never here.
        'Terminal Selected': props<{ epi: string }>(),

        /** Recents are per user + zone, so they load once the session is known. */
        'Recents Loaded': props<{ recentEpis: string[] }>(),
        /** Dispatched by whichever surface actually sent something to a device. */
        'Terminal Used': props<{ epi: string }>(),

        // A push settled, so the server has released its device lock and the
        // roster's `busy` badge is stale. Its own action rather than the Refresh
        // button's: a device still reading "In use" after the customer walked away
        // is the picker lying about the one thing it disables Send for.
        'Terminal Released': emptyProps(),
    },
});
